const FilterOutUniqueIds = (data) => {
  return data.filter((item, index, self) => index === self.findIndex((t) => t._id.toString() === item._id.toString()));
};

export default FilterOutUniqueIds;
